import { LocaldevKeysPage } from './LocaldevKeysPage';

export const LocaldevKeysTab = () => <LocaldevKeysPage embedded />;
